import { Link } from 'gatsby';
import React from 'react';

import Tag from '_components/tag';
import { urlForArticle, urlForArticleSearchTag } from '_utils/articles';
import { urlFor } from '_utils/images';

export default function ArticleCardV3({ article, variant = 'small' }) {
  if (variant === 'big') {
    return (
      <div className="shadow-card rounded-lg overflow-hidden">
        <div>
          <div className="p-4 md:p-8">
            <Link
              to={urlForArticle(article)}
              className="block text-base sm:text-2xl font-bold text-content-primary"
            >
              {article.title}
            </Link>
            <div className="hidden md:block text-xl mt-1 text-content-secondary">
              <div className="line-clamp-4">{article.excerpt}</div>
            </div>
            <div className="mt-2 sm:mt-4 flex gap-x-1">
              {article.tags_v3?.map((tag) => (
                <Link
                  key={tag.key.current}
                  to={urlForArticleSearchTag(tag)}
                >
                  <Tag>{tag.name}</Tag>
                </Link>
              ))}
            </div>
          </div>
          <Link
            to={urlForArticle(article)}
            className="block relative w-full pt-[56%] xl:pt-[56%]"
          >
            <div className="absolute inset-0">
              <img
                src={urlFor(article.thumbnail)?.format('webp').height(1600).url()}
                alt={article.title}
                className="h-full w-full object-cover object-center"
              />
            </div>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-x-3 sm:gap-x-4 xl:gap-x-8">
      <div className="w-32 h-24 sm:w-44 sm:h-32 xl:w-[378px] xl:h-[212px]">
        <Link
          to={urlForArticle(article)}
          className="block w-32 h-24 sm:w-44 sm:h-32 xl:w-[378px] xl:h-[212px] flex-shrink-0 relative"
        >
          <div className="absolute inset-0">
            <img
              src={urlFor(article.thumbnail)?.format('webp').height(512).url()}
              className="w-full h-full rounded-lg object-cover object-center"
              alt={article.thumbnail?.asset?.title}
            />
          </div>
        </Link>
      </div>
      <div className="xl:py-4 flex-1">
        <Link
          to={urlForArticle(article)}
          className="block font-bold text-sm sm:text-base lg:text-lg text-content-primary"
        >
          <div className="line-clamp-2">{article.title}</div>
        </Link>
        <div className="hidden sm:block mt-1 text-sm lg:text-base text-content-primary">
          <div className="line-clamp-2">{article.excerpt}</div>
        </div>
        <div className="mt-2 flex gap-x-1">
          {article.tags_v3?.map((tag) => (
            <Link key={tag.key.current} to={urlForArticleSearchTag(tag)}>
              <Tag>{tag.name}</Tag>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
